import React, { FC } from "react";
import { Link } from "../../ActionsSelectors/Link";
import { IABCSectionItem } from "./ABCTool.interface";

export const ABCSectionItem: FC<IABCSectionItem> = ({
  id,
  text,
  products,
  ...link
}) => (
  <li className="abc-list__li" data-testid="abcSectionItem-component">
    <Link classes={{ root: "abc-list__a" }} {...link}>
      <>
        {text}
        <span className="abc-list__total">{products}</span>
      </>
    </Link>
  </li>
);
